import getDefaultHeaders from '../utils/getDefaultHeaders';

export default {
  fetch(id, action, state) {
    return {
      url: `${state.getIn(['config', 'dataControllerApiUrl'])}/servicing/v1/member`,
      opts: {
        headers: getDefaultHeaders(),
        credentials: 'include',
      },
    };
  },
};
